<template>
	<div>
		<Cloader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<div class="row">
					<div class="col-lg-12">
						<label for="">Seleccione la Ubicación del Proyecto</label>
            	        <Search v-if="ShowMap" :oLatLng="oLatLng" :pOrigen="'proyecto'"></Search>
					</div>
				</div>
			</template>
		</Cloader>
	</div>
</template>

<script>
import Cloader from '@/components/CLoader.vue';
export default {
	components:{Cloader},
	name:'FormUbicacion',
	props:['Id','poBtnSave'],
	data() {
		return {
			ConfigLoad:{
				ShowLoader:false,
				ClassLoad:true
			},
			ShowMap:false,
			oLatLng:{
                Lat:null,
                Lng:null
            },
			EmitSeccion:this.poBtnSave.EmitSeccion,
			IdProyecto:0
		}
	},
	methods: {
		Guardar(){
			this.poBtnSave.toast=0; 
            this.poBtnSave.disableBtn=true;
			let formData=new FormData();
			formData.set('IdProyecto',this.IdProyecto);
			formData.set('Latitud', this.oLatLng.Lat);
            formData.set('Longitud', this.oLatLng.Lng);
			this.$http.post('proyecto/ubicacion/post',formData).then((res)=>{
				this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
				$('#'+this.poBtnSave.EmitSeccion).modal('hide');
			})
		},
		Recuperar(){
			this.ConfigLoad.ShowLoader=true;
			this.$http.get(
                'proyectossimple/recovery',
                {
                    params:{IdProyecto: this.IdProyecto}
                }
            ).then((res)=>{
				const objres=res.data.data.proyecto;
				this.oLatLng.Lat =parseFloat(objres.Latitud);
                this.oLatLng.Lng =parseFloat(objres.Longitud);
				this.ShowMap=true;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		Limpiar(){
			this.ShowMap=false;
			this.IdProyecto=0;
			this.oLatLng = {
				Lat: 19.43120339928868,
				Lng: -99.13450664719238
			};
		}
	},
	created() {
		this.bus.$off('NewModal_'+this.EmitSeccion);
		this.bus.$on('NewModal_'+this.EmitSeccion,(data,Id)=>{
			this.poBtnSave.disableBtn=false; 
			this.bus.$off('Save_'+this.EmitSeccion);
            this.bus.$on('Save_'+this.EmitSeccion,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
			this.IdProyecto=Id;
			this.Recuperar();
		})
	},
}
</script>
